module.exports = __webpack_public_path__ + "img/tutorial-08.2fb882dc.svg";